export const conditionalProp = (condition: boolean, property: string, value: unknown) => {
  if (!condition) return {}
  return { [property]: value }
}
